<template>
    <div>
        <loader v-if="!isDataAvailable" style="min-height: 100px;" />
        <div>
            <form class="form-horizontal">
                <div class="form-group">
                    <label class="col-sm-2 control-label text-label">Status History</label>
                    <div class="col-sm-10">
                        <div style="float: clear" v-if="isDataAvailable">
                            <v-client-table :data="gridWorkFlowInstanceStatus.tableData" :columns="gridWorkFlowInstanceStatus.columns" :options="gridWorkFlowInstanceStatus.options">
                            </v-client-table>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<style>
</style>

<script>
import loggingService from '@/services/util/loggingService'
import componentService from '@/services/util/componentService'
import dateService from '@/services/util/dateService'

import loader from '@/components/Loader.vue'

export default {
    components: {
        loader
    },
    name: 'workflowHistory',
    data: function () {
        return {
            isDebug: false
        }
    },
    props: {
        workflowInstanceStatusDtoList: {
            type: Array
        },
        hideSubmitUser: { default: false }
    },
    computed: {
        componentName: function () {
            return componentService.getComponentNameDebug(this)
        },
        isDataAvailable: function () {
            return this.workflowInstanceStatusDtoList != null
        },
        gridWorkFlowInstanceStatus: function () {
            var data = {
                tableData: this.formatWorkFlowData(this.workflowInstanceStatusDtoList),
                options: {
                    dateFormat: 'YYYY-MM-DD',
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    dateColumns: ['modifiedDate'],
                    headings: {
                        workflowStatusDescription: 'STATUS',
                        note: 'NOTE',
                        createdBy: 'USER',
                        createdDate: 'DATE',
                        duration: 'DURATION'
                    },
                    orderBy: {
                        ascending: true,
                        column: 'createdDate'
                    },
                    filterable: false
                }
            }
            if (this.hideSubmitUser) {
                data.columns = ['workflowStatusDescription', 'note', 'createdDate', 'duration']
            } else {
                data.columns = ['workflowStatusDescription', 'note', 'createdBy', 'createdDate', 'duration']
            }
            return data
        }
    },
    methods: {
        formatDate (date) {
            return dateService.fromMomentToString(date)
        },
        formatWorkFlowData (dataList) {
            dataList.forEach(data => {
                data.createdDate = this.formatDate(data.createdDate)
            })
            return dataList
        }
    },
    created () {
        loggingService.log(this.isDebug, this.componentName, 'created')
    },
    mounted () {
        loggingService.log(this.isDebug, this.componentName, 'mounted')
    },
    destroyed () {
        loggingService.log(this.isDebug, this.componentName, 'destroyed')
    }
}
</script>



// WEBPACK FOOTER //
// WorkflowHistory.vue?340d2f91